import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { recoverBooking } from '../../services/patientService';

/**
 * Cashfree return_url landing page: /payment/cashfree/return?order_id=...
 * Used when the payment page redirected (some mobile/in-app browsers) instead of
 * returning to the booking screen. Completes the booking for the paid order.
 */
export default function PaymentReturnPage() {
  const [params]  = useSearchParams();
  const navigate  = useNavigate();
  const [msg, setMsg] = useState('Confirming your payment...');

  useEffect(() => {
    let cancelled = false;
    const orderId = params.get('order_id') || (() => { try { return localStorage.getItem('pendingCashfreeOrder'); } catch (_) { return null; } })();
    if (!orderId) { navigate('/appointments', { replace: true }); return; }

    (async () => {
      for (let i = 0; i < 6 && !cancelled; i++) {
        try {
          const r = await recoverBooking(orderId);
          if (r?.success) {
            try { localStorage.removeItem('pendingCashfreeOrder'); } catch (_) {}
            if (!cancelled) navigate('/appointments', { replace: true });
            return;
          }
        } catch (e) {
          if (e?.response?.data?.refunded) { setMsg(e.message || 'Slot no longer available. Your payment has been refunded.'); return; }
          if (/refunded/i.test(e?.message || '')) { setMsg(e.message); return; }
        }
        await new Promise(r => setTimeout(r, 3000));
      }
      if (!cancelled) setMsg('Payment is being confirmed. Your booking will appear in My Appointments shortly. If money was deducted and nothing appears in 10 minutes, contact support.');
    })();
    return () => { cancelled = true; };
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-slate-50">
      <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin mb-4" />
      <p className="text-sm font-semibold text-slate-700">{msg}</p>
      <button onClick={() => navigate('/appointments')} className="mt-6 text-sm font-bold text-primary">
        Go to My Appointments
      </button>
    </div>
  );
}
